import { useSelector } from "react-redux";

const usePermissions = () => {
  const permissions = useSelector((state) => state.role.permissions);
  
  const hasPermission = (action, module) => {
    if (!permissions){return false;}
    if (permissions.length === 0) {return false;}
    for (var i = 0, n = permissions.length; i < n; i ++) {
      if (permissions[i] === `${action}:${module}`){
        return true
      }
      else if (permissions[i] === `${action}:*`){
        return true
      }
    }
    return false;
  };

  return { hasPermission };
};

export default usePermissions;
